
    import '/mnt/docs/components/index.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/mnt/docs/components/index.md?type=demo')
};